export default __webpack_public_path__ + "static/media/search-icon.65518cba.svg";